import React from 'react'
import RequestAppoinment from '../Components/MyDoctorRequestAppComp/RequestAppoinment'

const RequestAppoinmentView = () => {
  return (
    <div>
        <RequestAppoinment />
    </div>
  )
}

export default RequestAppoinmentView